import React from 'react';
import st from './EmptyPage.module.scss';
import FlexLine from "../../../../../../components/elements/flexLine/FlexLine";
import { Align, TextType } from "@baseTypes/baseType";
import ChartHeader from "../../../../../../components/elements/chart/ChartHeader";
import Tx from "../../../../../../types/naming";
import { EmptyTextBlock } from "../../../../crops/empty";

const EmptyPage = () => {
    return (
        <div className={st.empty_block}>
            <FlexLine textType={TextType.Header} style={{ paddingBottom: "24px" }}>
                <FlexLine><ChartHeader>{Tx.WorkProgressByDepartmentsAndCrops}</ChartHeader></FlexLine>
                <FlexLine align={Align.End}>
                    <svg width="400" height="24" viewBox="0 0 400 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="5" fill="#F0F0F0"/>
                        <rect x="28" y="8" width="80" height="8" rx="2" fill="#EAEAEB"/>
                        <circle cx="136" cy="12" r="5" fill="#F0F0F0"/>
                        <rect x="152" y="8" width="80" height="8" rx="2" fill="#EAEAEB"/>
                        <rect x="264" y="8" width="136" height="8" rx="2" fill="#EAEAEB"/>
                    </svg>
                </FlexLine>
            </FlexLine>
            <svg width="100%" height="326" viewBox="0 0 1200 326" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="16" width="20" height="20" rx="4" fill="#F0F0F0"/>
                <rect x="32" y="20" width="279" height="12" rx="5" fill="#EAEAEB"/>
                <rect x="408" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="28" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="1097" y="9" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <rect x="1097" y="35" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <path d="M1200 51.5H1025V52.5H1200V51.5Z" fill="#CCD9E0" mask="url(#path-5-inside-1_4269_64301)"/>
                <rect y="84" width="20" height="20" rx="4" fill="#F0F0F0"/>
                <rect x="32" y="88" width="279" height="12" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="68" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="96" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="1097" y="77" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <rect x="1097" y="103" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <path d="M1200 119.5H1025V120.5H1200V119.5Z" fill="#CCD9E0" mask="url(#path-13-inside-2_4269_64301)"/>
                <rect y="152" width="20" height="20" rx="4" fill="#F0F0F0"/>
                <rect x="32" y="156" width="279" height="12" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="136" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="164" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="1097" y="145" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <rect x="1097" y="171" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <path d="M1200 187.5H1025V188.5H1200V187.5Z" fill="#CCD9E0" mask="url(#path-21-inside-3_4269_64301)"/>
                <rect y="221" width="20" height="20" rx="4" fill="#F0F0F0"/>
                <rect x="32" y="225" width="279" height="12" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="204" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="234" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="1097" y="214" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <rect x="1097" y="240" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <path d="M1200 257.5H1025V258.5H1200V257.5Z" fill="#CCD9E0" mask="url(#path-29-inside-4_4269_64301)"/>
                <rect y="290" width="20" height="20" rx="4" fill="#F0F0F0"/>
                <rect x="32" y="290" width="279" height="12" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="274" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="408" y="302" width="585" height="24" rx="5" fill="#EAEAEB"/>
                <rect x="1097" y="283" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <rect x="1097" y="309" width="95" height="8" rx="2" fill="#EAEAEB"/>
                <path d="M1200 325.5H1025V326.5H1200V325.5Z" fill="#CCD9E0" mask="url(#path-37-inside-5_4269_64301)"/>
                <svg width="1264" height="357" viewBox="0 0 1264 357" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="1264" height="357" transform="translate(0 -22)" fill="url(#paint0_linear_4269_64522)"/>
                    <defs>
                        <linearGradient id="paint0_linear_4269_64522" x1="632" y1="-35.4804" x2="632" y2="434.355"
                                        gradientUnits="userSpaceOnUse">
                            <stop stopColor="white" stopOpacity="0"/>
                            <stop offset="1" stopColor="white"/>
                        </linearGradient>
                    </defs>
                </svg>
            </svg>
            <EmptyTextBlock />
        </div>
    )
}

export default EmptyPage;